import { createSvgIcon } from '@mui/material';

export const VaultIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
    <path
      fill="currentColor"
      d="M3.75016 9.16669 4.5835 10l3.68333-3.33331 1.54551 1.12693c.64956.47367 1.54476.41609 2.12836-.1369l3.3928-3.21503v1.39166h1.3333V1.66669h-4v1.38889h1.3167l-3.05 2.74305-1.41685-1.03312c-.70483-.51393-1.68671-.39745-2.25173.26712zM3.3335 13.3334v3.3333h3.33333v-3.3333zM8.3335 10.8334v5.8333h3.3333v-5.8333zM13.3335 9.16669v7.50001h3.3333V9.16669z"
    />
  </svg>,
  'VaultIcon',
);
